import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class TripService {
  fetchTrips = (
    page = 1,
    pageSize = 10,
    status = '',
    fromDate = null,
    toDate = null,
    search = '',
  ) => {
    let url = `${BASE_URL}/v1/trips?page=${page}&pageSize=${pageSize}`;

    if (status) {
      url += `&status=${status}`;
    }

    if (fromDate) {
      const formattedFromDate =
        fromDate instanceof Date
          ? fromDate.toISOString().split('T')[0]
          : fromDate.format
            ? fromDate.format('YYYY-MM-DD')
            : fromDate;
      url += `&fromDate=${formattedFromDate}`;
    }

    if (toDate) {
      const formattedToDate =
        toDate instanceof Date
          ? toDate.toISOString().split('T')[0]
          : toDate.format
            ? toDate.format('YYYY-MM-DD')
            : toDate;
      url += `&toDate=${formattedToDate}`;
    }

    if (search) {
      if (/^\d+$/.test(search)) {
        if (search.length <= 5) {
          url += `&tripId=${search}`;
        } else {
          url += `&phoneNo=${search}`;
        }
      } else {
        url += `&search=${search}`;
      }
    }

    return axiosInstance
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        // Transform the response to match expected format
        // Handle nested response structure (response.data.data) or direct structure (response.data)
        const responseData = response.data?.data || response.data;

        if (responseData) {
          // Extract pagination from API response (camelCase: totalRecords, page, pageSize)
          const apiTotalRecords = responseData.totalRecords;
          const apiPage = responseData.page;
          const apiPageSize = responseData.pageSize;

          return {
            ...response,
            data: {
              status: response.data?.status,
              message: response.data?.message,
              data: {
                result: responseData.result,
                total_records: apiTotalRecords,
                page: apiPage,
                page_size: apiPageSize,
              },
              status_code: response.data?.status_code,
            },
          };
        }
        return response;
      });
  };

  deleteTrip = (id) => {
    return axiosInstance.delete(`${BASE_URL}/v1/trips/${id}`);
  };

  createTrip = (tripData) => {
    return axiosInstance.post(`${BASE_URL}/v1/trips`, tripData, {
    });
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TripService();
